const generateOAuthUrl = () =>
  `${process.env.REACT_APP_VERITONE_OAUTH_BASE_URL}?response_type=token&client_id=${process.env.REACT_APP_VERITONE_APP_ID}&redirect_uri=${process.env.REACT_APP_VERITONE_OAUTH_REDIRECT_URL}?provider=aiware`

// function generateOAuthUrl() {
//   const hardcodedClientId = '83860927-28fa-421d-a37c-7ab540ff6e46';
//   console.log('Using hardcoded client id:', hardcodedClientId);
//   return `${process.env.REACT_APP_VERITONE_OAUTH_BASE_URL}?response_type=token&client_id=${hardcodedClientId}&redirect_uri=${process.env.REACT_APP_VERITONE_OAUTH_REDIRECT_URL}?provider=aiware`;
// }


export default generateOAuthUrl
